import React, { forwardRef, useState, useMemo, useEffect } from "react";
import "../../Styles/CommonStyles.scss";
import "../../Styles/TableStyles.scss";
import Select from "react-select";
import { useTable, Column, useSortBy, Row } from "react-table";
import { COLUMNS, dummy_COLUMNS } from "./FindMemberListColumns";
import MemberServices from "../../services/MemberServices";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import MemberDetail from "../MemberDetail/MemberDetail";
import { useDispatch, useSelector } from "react-redux";
import { changeCurrentMemberMenu } from "../../store/screenSlice";
import { screenConfig } from "../../config/screenConfig";
import { updateFM_MemberId } from "../../store/memberApiSlice";
import { useAppSelector, useAppDispatch } from "../../store/hooks";

import { assignCurrentMember } from "../../store/currentMemberSlice";
import { updateMemberList } from "../../store/findMemberUpdatedApiSlice";
import AlertWithModal from "../utilityComponents/AlertWithModal";

const FindMemberListSavedQuery: React.FC = () => {
  const [memberList, setMemberList] = useState<any[]>([]);
  const dispatch = useDispatch();
  const currentMember = useAppSelector((state) => state.currentMember);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");

  const columns = React.useMemo<Column<any>[]>(
    () => [
      { id: "BarId", Header: "BarID", accessor: "BarId" },
      { id: "FirstName", Header: "FirstName", accessor: "FirstName" },
      { id: "LastName", Header: "LastName", accessor: "LastName" },
      { id: "MemberCode", Header: "MemberCode", accessor: "MemberCode" },
      { id: "MemberType", Header: "MemberType", accessor: "MemberType" },
      // { id: "Phoneno", Header: "Phone Number", accessor: "Phoneno" },
      { id: "Gender", Header: "Gender", accessor: "Gender" },
      {
        id: "LastPaidDueDate",
        Header: "Last Paid Dues Date",
        accessor: (LastPaidDueDate) => {
          return moment(LastPaidDueDate.LastPaidDueDate)
            .local()
            .format("MM-DD-YYYY");
        },
      },
      {
        id: "AdmitDate",
        Header: "AdmitDate",
        accessor: (AdmitDate) => {
          return moment(AdmitDate.AdmitDate).local().format("MM-DD-YYYY");
        },
      },
    ],
    []
  );

  const data = useMemo(() => memberList, [memberList]);

  useEffect(() => {
    const getMemberLsit = async () => {
      console.log("getAdminList called");
      const searchString = currentMember.SearchId;
      setIsLoading(true);

      const response = await MemberServices.executeSavedSearch({
        SearchId: searchString,
      });
      // console.log("response...", response.data.data.Members);
      if (response.data.data != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        console.log("Success");
        setMemberList(response.data.data.Members);
        setIsLoading(false);

        dispatch(updateMemberList(response.data.data.Members));
      } else {
        setIsLoading(false);
      }
    };

    getMemberLsit();
  }, []);

  const TableInstance = useTable(
    {
      columns,
      data,
    },
    useSortBy
  );

  console.log("memberlist2:", data);

  const getMemberDetail = (row: Row<any>) => {
    let data = row.original;
    console.log("getMemberDetail:", data);

    dispatch(assignCurrentMember(data));
    dispatch(updateFM_MemberId(data.Id));
    dispatch(changeCurrentMemberMenu(screenConfig.memberDetailScreen));
  };

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    TableInstance;

  let index = 0; //to revisit later
  return (
    <div className="dashboard-content-wrapper">
      <h1 className="page-heading">Search Result</h1>
      <div className="memberlist-table">
        <table {...getTableProps}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps} key={index++}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()} key={column.id}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          {memberList.length === 0 ? (
            isLoading ? (
              <tbody>
                <tr>
                  <td align="center" colSpan={9}>
                    <span>Loading:{isLoading}</span>
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody>
                <tr>
                  <td align="center" colSpan={9}>
                    <span>No record Found:{isLoading}</span>
                  </td>
                </tr>
              </tbody>
            )
          ) : (
            <tbody {...getTableBodyProps}>
              {rows.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()} key={row.index}>
                    {row.cells.map((cell) => {
                      return (
                        <td
                          onClick={() => getMemberDetail(row)}
                          {...cell.getCellProps()}
                        >
                          {" "}
                          {cell.render("Cell")}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          )}
        </table>
      </div>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default FindMemberListSavedQuery;
